const removeOldCrops = (issue, listOfCrops) => {
    for (const key in issue) {
        if (!listOfCrops.includes(key.toLowerCase())) {
            issue[key] = {};
        }
    }
    return null;
}
export default removeOldCrops;